var map = {
	"./Achievements/airplane.svg": 154,
	"./Achievements/board.svg": 155,
	"./Achievements/brofist.svg": 156,
	"./Achievements/certification.svg": 157,
	"./Achievements/champagne.svg": 158,
	"./Achievements/coffee.svg": 159,
	"./Achievements/elephant.svg": 160,
	"./Achievements/entrance.svg": 161,
	"./Achievements/flag.svg": 162,
	"./Achievements/graduate.svg": 163,
	"./Achievements/gym.svg": 164,
	"./Achievements/hand-with-ruby.svg": 165,
	"./Achievements/light-fixture.svg": 166,
	"./Achievements/loudspeaker.svg": 167,
	"./Achievements/medal.svg": 168,
	"./Achievements/ninja.svg": 169,
	"./Achievements/partnership.svg": 170,
	"./Achievements/puzzle-piece.svg": 171,
	"./Achievements/shoes.svg": 172,
	"./Achievements/sun-with-cloud.svg": 173,
	"./Achievements/target.svg": 174,
	"./Achievements/trophy.svg": 175,
	"./Game/ball-shoe.svg": 292,
	"./Game/bell.svg": 293,
	"./Game/book-with-glasses.svg": 294,
	"./Game/book.svg": 295,
	"./Game/brick-wall.svg": 296,
	"./Game/certificate.svg": 297,
	"./Game/chess.svg": 298,
	"./Game/clipboard.svg": 299,
	"./Game/control.svg": 300,
	"./Game/essay.svg": 301,
	"./Game/filled-polygon.svg": 251,
	"./Game/hourglass.svg": 302,
	"./Game/ice-cream.svg": 303,
	"./Game/pendulum.svg": 304,
	"./Game/polygon.svg": 252,
	"./Game/ruby.svg": 257,
	"./Game/test.svg": 305,
	"./cap.svg": 176,
	"./coffee-and-book.svg": 177,
	"./computerLock.svg": 178,
	"./diagonal-left-border.svg": 179,
	"./diagonal-right-border.svg": 180,
	"./f-arrow.svg": 181,
	"./history.svg": 182,
	"./logo.svg": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;